import template from './menu.html';
import './menu.scss';

export default {
  template,
  bindings: {
    options: '<',
    selected: '<',
  },
};
